// Sponsor pricing & Firestore constants
// Prices are in TWD (integer). Adjust freely — Stripe Price IDs must match these if using fixed Prices.
export const COFFEE_PRICE_TWD = 90;
export const MOCKTAIL_PRICE_TWD = 180;

export const SPONSORSHIP_COLLECTION = 'project_sponsorships';

// Stripe
export const STRIPE_PUBLISHABLE_KEY =
    process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || '';

// Optional: pre-created Stripe Payment Links per drink type.
// If provided, we redirect straight to the link (no server needed).
// Format in env: a JSON object keyed by 'coffee'/'mocktail'.
// Simpler env vars used below.
export const STRIPE_PAYMENT_LINK_COFFEE =
    process.env.REACT_APP_STRIPE_LINK_COFFEE || '';
export const STRIPE_PAYMENT_LINK_MOCKTAIL =
    process.env.REACT_APP_STRIPE_LINK_MOCKTAIL || '';

export const SPONSOR_AMOUNT_TWD = {
    coffee: COFFEE_PRICE_TWD,
    mocktail: MOCKTAIL_PRICE_TWD,
};

export const SPONSOR_EMOJI = {
    coffee: '☕',
    mocktail: '🍹',
};
